{
  "enum": {
    "IxcProxyvoteV1ProxyJobStatus": {
      "DONE": "Done",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcProxyvoteV1ProxyTaskStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcProxyvoteV1TaskUpdatedStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcProxyvoteV1ProxyJobQueryServiceProxyJobListFilterableFields": {
      "jobId": "Job",
      "status": "Status"
    },
    "IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListFilterableFields": {
      "jobId": "Job",
      "status": "Status",
      "taskId": "Task"
    }
  },
  "oneOf": {
    "IxcProxyvoteV1ProxyJobEventType": {
      "allFinished": "All Finished",
      "created": "Created",
      "taskUpdated": "Task Updated"
    },
    "IxcProxyvoteV1ProxyTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished"
    }
  },
  "sortEnum": {
    "IxcProxyvoteV1ProxyJobQueryServiceProxyJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcProxyvoteV1ProxyTaskQueryServiceProxyTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}